import { Modal, Form, Input, Button, Card } from "antd";
import { PlusOutlined, DeleteOutlined } from "@ant-design/icons";
import { useEffect } from "react";
import { createCategory, updateCategory } from "../../utils/API";

const AddCategoryModal = ({ open, onClose, refresh, editData }: any) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (editData) {
      form.setFieldsValue({
        categoryName: editData.catName,
        subCategories: editData.SubCategories?.map((s: any) => ({
          subCatName: s.subCatName,
        })),
      });
    } else {
      form.resetFields();
    }
  }, [editData]);

  const handleSubmit = async (values: any) => {
    const payload = {
      catName: values.categoryName,
      subcategories: values.subCategories || [],
    };

    if (editData) {
      await updateCategory(editData.catId, payload);
    } else {
      await createCategory(payload);
    }

    onClose();
    refresh();
    form.resetFields();
  };

  return (
    <Modal
      title={
        <span className="text-xl font-normal text-gray-800">
          {editData ? "Edit Category" : "Add Category"}
        </span>
      }
      open={open}
      onCancel={onClose}
      footer={null}
      centered
      width={750}
    >
      <Form
        form={form}
        layout="vertical"
        requiredMark={false}
        className="mt-4"
        onFinish={handleSubmit}
      >
        <Form.Item
          label={
            <span className="text-gray-800 font-medium">Category Name</span>
          }
          name="categoryName"
        >
          <Input
            size="large"
            placeholder="Category Name"
            className="rounded-lg border-gray-300 hover:border-gray-400 focus:border-[#004aad]"
          />
        </Form.Item>

        <Form.List name="subCategories">
          {(fields, { add, remove }) => (
            <>
              {/* Header */}
              <div className="mb-3">
                <span className="text-gray-800 font-medium">
                  Sub Categories
                </span>
              </div>

              {/* List */}
              {fields.map((field, index) => (
                <Card
                  key={field.key}
                  className="mb-3 rounded-xl border border-gray-200 shadow-sm"
                  bodyStyle={{ padding: "12px 16px" }}
                >
                  <div className="flex items-center gap-3">
                    {/* Index */}
                    <div className="text-gray-400 w-6">{index + 1}.</div>

                    {/* Input */}
                    <Form.Item
                      {...field}
                      name={[field.name, "subCatName"]}
                      className="flex-1 mb-0"
                      rules={[{ required: true, message: "Enter subcategory" }]}
                    >
                      <Input
                        placeholder="Enter sub category name"
                        size="large"
                        className="rounded-lg"
                      />
                    </Form.Item>

                    {/* Delete Button */}
                    <Button
                      danger
                      type="text"
                      icon={<DeleteOutlined />}
                      onClick={() => remove(field.name)}
                    />
                  </div>
                </Card>
              ))}

              {/* Empty State */}
              {fields.length === 0 && (
                <div className="text-gray-400 text-center py-6 border rounded-lg mb-3">
                  No subcategories added
                </div>
              )}

              {/* Add Button at Bottom */}
              <div className="flex justify-center mt-2">
                <Button
                  type="dashed"
                  icon={<PlusOutlined />}
                  onClick={() => add()}
                  className="w-full md:w-auto"
                >
                  Add Sub Category
                </Button>
              </div>
            </>
          )}
        </Form.List>

        <div className="flex justify-end gap-4 mt-12">
          <Button
            onClick={onClose}
            className="h-9 px-8 rounded-lg border-none bg-gray-100 hover:bg-gray-200 text-gray-700 font-medium"
          >
            Cancel
          </Button>

          <Button
            type="primary"
            htmlType="submit"
            className="h-9 px-8 rounded-lg bg-[#004aad] hover:bg-blue-800 border-none text-white font-medium"
          >
            {editData ? "Update" : "Add"}
          </Button>
        </div>
      </Form>
    </Modal>
  );
};

export default AddCategoryModal;
